import { useState } from "react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { NumberInput } from "@/components/ui/number-input";
import { useUpdateWorkspace } from "@/hooks/use-workspaces";

import type { Workspace } from "@artisancode/api-types";

export function DailyWageRateCard({ workspace }: { workspace: Workspace }) {
  const { mutate: updateWorkspace, isPending } = useUpdateWorkspace();
  const [rate, setRate] = useState(workspace.riderDailyWageRate);

  function handleSave() {
    updateWorkspace(
      { id: workspace.id, riderDailyWageRate: Math.max(0, rate) },
      {
        onSuccess: () => toast.success("Tarif gaji harian rider diperbarui."),
        onError: () => toast.error("Gagal menyimpan tarif gaji harian."),
      },
    );
  }

  return (
    <Card className="bg-muted/20">
      <CardContent className="space-y-3 pt-6">
        <div className="border-b pb-2">
          <p className="text-sm font-semibold">Gaji Harian Rider</p>
          <p className="text-[11px] text-muted-foreground">
            Tarif tetap per hari kerja, dipakai di Penggajian Rider ("Gaji
            Harian" = tarif × jumlah hari kerja dalam periode).
          </p>
        </div>
        <div className="flex flex-col gap-2 sm:max-w-xs">
          <Label className="text-xs">Tarif per Hari (Rp)</Label>
          <NumberInput placeholder="0" value={rate} onChange={setRate} />
          <Button
            type="button"
            size="sm"
            className="self-start"
            onClick={handleSave}
            disabled={isPending || rate === workspace.riderDailyWageRate}
          >
            {isPending ? "Menyimpan..." : "Simpan"}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
